export type Language = string;
export type Namespace = string;

export enum LanguageDirection {
    'ltr' = 'ltr',
    'rtl' = 'rtl',
}
